import { View } from 'backbone.marionette';
import template from './zendeskFAQs.jst';

export default class FAQsView extends View {
	get template() {
		return template;
	}

	get className() {
		return "help-page faqs-page";
	}

	async initialize() {
		await this.fetchData();

		this.model.set({
			faqsItems: this.collection.faqsItems,
		});

		this.render();
	}

	fetchData() {
		return Promise.all( [
			this.collection.fetch()
		] );
	}
}